import { gql } from 'apollo-angular';

export const USER_SETTINGS_QUERY = gql`
  query getCurrentUsersSettings {
    currentUserSettings: getCurrentUsersSettings
  }
`;

export interface UserSettingsQueryResponse {
  currentUserSettings: any;
}
